export const faqs = [
  {
    question: '草榴社区技术讨论区是什么？',
    answer: '草榴社区技术讨论区是一个面向技术爱好者的专业交流平台，汇聚了编程开发、网络安全、人工智能、运维架构等各类技术话题。我们致力于为技术人员提供高质量的技术讨论、经验分享与问题解答服务，帮助每一位成员在技术道路上快速成长。',
  },
  {
    question: '如何加入社区参与讨论？',
    answer: '您可以直接注册账号加入我们的社区。注册完成后即可浏览所有技术文章、参与评论讨论、发布技术问题。我们也欢迎您分享自己的技术经验和心得，与社区成员共同进步。',
  },
  {
    question: '社区的技术文章质量如何保证？',
    answer: '我们设有专业的审核团队，对所有发布的文章进行质量审核。同时，社区采用点赞、评论、浏览量等多维度指标来评价文章质量，优质内容会获得更多曝光。我们鼓励原创技术内容，反对抄袭和低质量转载。',
  },
  {
    question: '可以在社区提问寻求帮助吗？',
    answer: '当然可以！技术问答是我们社区的核心功能之一。您可以详细描述您遇到的技术问题，社区中的技术专家会尽快为您提供解答。建议在提问时附上相关代码、错误信息和已尝试的解决方案，这样能获得更精准的帮助。',
  },
  {
    question: '社区支持哪些技术领域的讨论？',
    answer: '社区目前涵盖编程开发、网络安全、人工智能、运维架构、数据库技术、移动开发等六大核心领域。每个领域下还有更细分的讨论话题。如果您关注的领域暂时没有覆盖，也欢迎向我们反馈，我们会考虑增设新的讨论分类。',
  },
];